import React from "react";
import { Tooltip } from "antd";

const styles = {
  overflow: "hidden",
  maxWidth: "400px",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const tooltipStyles = {
  fontSize: "13px",
  backgroundColor: "#4d4d4d",
};

const ActiveOutlets = ({ outletList, activeOutlets }) => {
  const getOutletLabel = () => {
    const labelOutlets = [];
    outletList?.forEach((outlet) => {
      if (activeOutlets.includes(outlet.value)) {
        labelOutlets.push(outlet.label);
      }
    });
    return labelOutlets.join(", ") || "-";
  };

  return (
    <Tooltip
      overlayInnerStyle={tooltipStyles}
      title={getOutletLabel(outletList, activeOutlets)}
      placement="bottomRight"
    >
      <div style={styles}>
        <span style={{ color: "#bdbfc2" }}>Cabang Aktif:</span>{" "}
        {getOutletLabel(outletList, activeOutlets)}
      </div>
    </Tooltip>
  );
};

export default ActiveOutlets;
